import Vue from "vue"
//@ts-ignore

Vue.config.errorHandler = async function(err: any, vm, info) {
  alert(err?.response?.message || err || "Error ao sincronizar dados")

}
